import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exerciseItemWrapper: {
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
  },
  exerciseTitle: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  exerciseItemContent: {
    maxWidth: 'calc(100% - 56px)',
    minWidth: 0,
    flex: 1,
  },
  exerciseItemInfoWrapper: {
    width: '100%',
    minWidth: 0,
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
}));
